import script from "./messageItem.vue?vue&type=script&setup=true&name=MessageItem&lang=js"
export * from "./messageItem.vue?vue&type=script&setup=true&name=MessageItem&lang=js"

import "./messageItem.vue?vue&type=style&index=0&id=727f58f3&scoped=true&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-727f58f3"]])

export default __exports__